namespace PaperTrail.NewsletterControl {
    export interface StoryTextBlockRow {
        StoryTextBlockId?: number;
        StoryId?: number;
        Title?: string;
        Content?: string;
        StyleSheetId?: number;
        StoryUserId?: number;
        StoryNewsletterId?: number;
        StoryDateSubmitted?: string;
        StoryDateModified?: string;
        StoryDatePublished?: string;
        StoryTitle?: string;
        StorySubtitle?: string;
        StoryPage?: number;
        StoryPosition?: number;
        StoryCharacters?: number;
        StoryDoPageBreak?: boolean;
        StoryRows?: number;
        StoryColumns?: number;
        StoryIsPlaced?: boolean;
        StoryStyleSheetId?: number;
        StoryRank?: number;
        StoryPageTemplateId?: number;
        StoryPageTemplateSectionId?: number;
        StyleSheetTitle?: string;
        StyleSheetFont?: string;
        StyleSheetFontSize?: number;
        StyleSheetTextAlignment?: string;
        StyleSheetHeight?: number;
        StyleSheetWidth?: number;
        StyleSheetPadding?: string;
        StyleSheetMargin?: string;
        StyleSheetRows?: number;
        StyleSheetColumns?: string;
        StyleSheetRotation?: number;
        StyleSheetBackgroundColor?: string;
        StyleSheetForeColor?: string;
        StyleSheetIsUnderline?: boolean;
        StyleSheetIsBold?: boolean;
        StyleSheetIsItalic?: boolean;
    }

    export namespace StoryTextBlockRow {
        export const idProperty = 'StoryTextBlockId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'NewsletterControl.StoryTextBlock';
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            StoryTextBlockId = "StoryTextBlockId",
            StoryId = "StoryId",
            Title = "Title",
            Content = "Content",
            StyleSheetId = "StyleSheetId",
            StoryUserId = "StoryUserId",
            StoryNewsletterId = "StoryNewsletterId",
            StoryDateSubmitted = "StoryDateSubmitted",
            StoryDateModified = "StoryDateModified",
            StoryDatePublished = "StoryDatePublished",
            StoryTitle = "StoryTitle",
            StorySubtitle = "StorySubtitle",
            StoryPage = "StoryPage",
            StoryPosition = "StoryPosition",
            StoryCharacters = "StoryCharacters",
            StoryDoPageBreak = "StoryDoPageBreak",
            StoryRows = "StoryRows",
            StoryColumns = "StoryColumns",
            StoryIsPlaced = "StoryIsPlaced",
            StoryStyleSheetId = "StoryStyleSheetId",
            StoryRank = "StoryRank",
            StoryPageTemplateId = "StoryPageTemplateId",
            StoryPageTemplateSectionId = "StoryPageTemplateSectionId",
            StyleSheetTitle = "StyleSheetTitle",
            StyleSheetFont = "StyleSheetFont",
            StyleSheetFontSize = "StyleSheetFontSize",
            StyleSheetTextAlignment = "StyleSheetTextAlignment",
            StyleSheetHeight = "StyleSheetHeight",
            StyleSheetWidth = "StyleSheetWidth",
            StyleSheetPadding = "StyleSheetPadding",
            StyleSheetMargin = "StyleSheetMargin",
            StyleSheetRows = "StyleSheetRows",
            StyleSheetColumns = "StyleSheetColumns",
            StyleSheetRotation = "StyleSheetRotation",
            StyleSheetBackgroundColor = "StyleSheetBackgroundColor",
            StyleSheetForeColor = "StyleSheetForeColor",
            StyleSheetIsUnderline = "StyleSheetIsUnderline",
            StyleSheetIsBold = "StyleSheetIsBold",
            StyleSheetIsItalic = "StyleSheetIsItalic"
        }
    }
}
